import { navigationConstants } from "./navigation.constants";
import { Integration } from "../../_statics/Integration";
import stringUtils from "../string-utils";
import { OrganizationType } from "../../_statics/OrganizationType";
import { UserRole } from "../../_statics/UserStatics";

export function navigation(state = { items: [] }, action) {
    switch (action.type) {
        case navigationConstants.UPDATE_NAVIGATION_ITEMS: {
            const items = [];
            // Zalando is super-user-only for now (#40558/#41277) — gate its nav entries by role.
            const isZalandoVisible =
                action.userRole === UserRole.SUPER_USER || action.userRole === UserRole.TECHNICAL_USER;

            items.push({
                name: "Übersicht",
                url: "/",
                icon: "fa fa-home",
                attributes: {
                    dataCy: "home-nav-button",
                },
                class: "",
            });

            // User management ("Benutzerverwaltung") is only visible to the Kanzleiadmin of a Steuerkanzlei (#41913).
            if (action.isKanzleiadmin) {
                items.push({
                    name: "Benutzerverwaltung",
                    url: "/user-management",
                    icon: "fa fa-users",
                    attributes: {
                        dataCy: "user-management-nav-button",
                    },
                });
            }

            // Standardmandat (StB Dashboard V5, #42278) — kanzleiweite Kontierungs-Vorlage. Visible to every
            // user of a Steuerkanzlei (tax agency) for now.
            if (action.organizationType === OrganizationType.TAX_AGENCY) {
                items.push({
                    name: "Standardmandat",
                    url: "/standardmandat",
                    icon: "fa fa-sliders-h",
                    attributes: {
                        dataCy: "standardmandat-nav-button",
                    },
                });
            }

            // Steuerkanzlei V6 audit log (#41918) — visible ONLY to pathway Super Users (read-only) and ONLY when
            // the selected organization is a Steuerkanzlei (tax agency). Routes to the audit tab of the admin area
            // (/adminarea/:module -> navSelection = "kanzlei-audit").
            if (action.userRole === UserRole.SUPER_USER && action.organizationType === OrganizationType.TAX_AGENCY) {
                items.push({
                    name: "Audit Log",
                    url: "/adminarea/kanzlei-audit",
                    icon: "fa fa-shield-alt",
                    attributes: {
                        dataCy: "kanzlei-audit-nav-button",
                    },
                });
            }

            // Show Export App as a teaser for Customer that have only Rechnungsprinter installed
            if (
                action?.allowedApps?.includes("PATHWAY_BILLING") &&
                !action?.allowedApps?.includes("SHOPIFY") &&
                !action?.allowedModules?.includes("SHOPS")
            ) {
                items.push({
                    title: true,
                    name: "DATEV Export",
                    wrapper: {
                        element: "",
                        attributes: {},
                    },
                    class: "",
                });
                items.push({
                    name: "Shopify",
                    url: "/information/shopify",
                    icon: "fab fa-shopify",
                    attributes: {
                        dataCy: "shopify-billing-nav-button",
                    },
                });
            }

            if (action.organizationType === OrganizationType.LEXOFFICE) {
                items.push({
                    title: true,
                    name: "LexOffice",
                    wrapper: {
                        // optional wrapper object
                        element: "", // required valid HTML5 element tag
                        attributes: {}, // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
                    },
                    class: "", // optional class names space delimited list for title item ex: "text-center"
                });
                items.push({
                    name: "Dashboard",
                    url: "/lexoffice",
                    icon: "fa fa-cart-arrow-down",
                    attributes: {
                        dataCy: "lexoffice-dashboard-nav-button",
                    },
                });
                items.push({
                    name: "Einstellungen",
                    url: "/lexoffice-settings",
                    icon: "fa fa-cogs",
                    attributes: {
                        dataCy: "lexoffice-settings-nav-button",
                    },
                });
                return { items: items };
            }

            //SHOPS
            if (action.allowedModules.includes("SHOPS")) {
                items.push({
                    title: true,
                    name: "Shopsysteme",
                    wrapper: {
                        // optional wrapper object
                        element: "", // required valid HTML5 element tag
                        attributes: {}, // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
                    },
                    class: "", // optional class names space delimited list for title item ex: "text-center"
                });
            }
            if (action.allowedApps.includes("SHOPIFY")) {
                items.push({
                    name: Integration.SHOPIFY.name,
                    url: "/integrations" + Integration.SHOPIFY.integrationPath,
                    icon: Integration.SHOPIFY.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.SHOPIFY.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("SNIPCART")) {
                items.push({
                    name: Integration.SNIPCART.name,
                    url: "/integrations" + Integration.SNIPCART.integrationPath,
                    icon: Integration.SNIPCART.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.SNIPCART.identifier) +
                            "-nav-button",
                    },
                });
            }
            if (action.allowedApps.includes("STOREGANISE")) {
                items.push({
                    name: Integration.STOREGANISE.name,
                    url: "/integrations" + Integration.STOREGANISE.integrationPath,
                    icon: Integration.STOREGANISE.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.STOREGANISE.identifier) +
                            "-nav-button",
                    },
                });
            }
            if (action.allowedApps.includes("TIKTOK_SHOP")) {
                items.push({
                    name: Integration.TIKTOK_SHOP.name,
                    url: "/integrations" + Integration.TIKTOK_SHOP.integrationPath,
                    icon: Integration.TIKTOK_SHOP.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.TIKTOK_SHOP.identifier) +
                            "-nav-button",
                    },
                });
            }
            if (action.allowedApps.includes("ABOUT_YOU")) {
                items.push({
                    name: Integration.ABOUT_YOU.name,
                    url: "/integrations" + Integration.ABOUT_YOU.integrationPath,
                    icon: Integration.ABOUT_YOU.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.ABOUT_YOU.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("EBAY")) {
                items.push({
                    name: Integration.EBAY.name,
                    url: "/integrations" + Integration.EBAY.integrationPath,
                    icon: Integration.EBAY.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.EBAY.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("KAUFLAND")) {
                items.push({
                    name: Integration.KAUFLAND.name,
                    url: "/integrations" + Integration.KAUFLAND.integrationPath,
                    icon: Integration.KAUFLAND.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.KAUFLAND.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("OTTO")) {
                items.push({
                    name: Integration.OTTO.name,
                    url: "/integrations" + Integration.OTTO.integrationPath,
                    icon: Integration.OTTO.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.OTTO.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("ZALANDO") && isZalandoVisible) {
                items.push({
                    name: Integration.ZALANDO.name,
                    url: "/integrations" + Integration.ZALANDO.integrationPath,
                    icon: Integration.ZALANDO.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.ZALANDO.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("WOO_COMMERCE")) {
                items.push({
                    name: Integration.WOO_COMMERCE.name,
                    url: "/integrations" + Integration.WOO_COMMERCE.integrationPath,
                    icon: Integration.WOO_COMMERCE.icon,
                    attributes: {
                        dataCy: "woocommerce-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("AMAZON_ORDER")) {
                items.push({
                    name: Integration.AMAZON_ORDER.name,
                    url: "/integrations" + Integration.AMAZON_ORDER.integrationPath,
                    icon: Integration.AMAZON_ORDER.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.AMAZON_ORDER.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("AMAZON")) {
                items.push({
                    name: "Amazon",
                    url: "/integrations/amazon/overview",
                    icon: Integration.AMAZON.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.AMAZON.identifier) +
                            "-nav-button",
                    },
                });
            }
            if (
                action.allowedApps.includes("SHOPIFY") ||
                action.allowedApps.includes("WOO_COMMERCE") ||
                action.allowedApps.includes("AMAZON")
            ) {
                items.push({
                    name: "OSS Dashboard",
                    url: "/integrations/oss",
                    icon: "fas fa-chart-line",
                    attributes: {
                        dataCy: "oss-dashboard-nav-button",
                    },
                });
            }

            // BOOKING
            if (action.allowedModules.includes("BOOKING")) {
                items.push({
                    title: true,
                    name: "Booking-Anbieter",
                    wrapper: {
                        // optional wrapper object
                        element: "", // required valid HTML5 element tag
                        attributes: {}, // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
                    },
                    class: "", // optional class names space delimited list for title item ex: "text-center"
                });
            }

            if (action.allowedApps.includes("CHARGEBEE")) {
                items.push({
                    name: Integration.CHARGEBEE.name,
                    url: "/integrations" + Integration.CHARGEBEE.integrationPath,
                    icon: Integration.CHARGEBEE.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.CHARGEBEE.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("STRIPE_BILLING")) {
                items.push({
                    name: Integration.STRIPE_BILLING.name,
                    url: "/integrations" + Integration.STRIPE_BILLING.integrationPath,
                    icon: Integration.STRIPE_BILLING.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.STRIPE_BILLING.identifier) +
                            "-nav-button",
                    },
                });
            }

            // PAYMENT
            if (action.allowedModules.includes("PAYMENT")) {
                items.push({
                    title: true,
                    name: "Payment-Anbieter",
                    wrapper: {
                        // optional wrapper object
                        element: "", // required valid HTML5 element tag
                        attributes: {}, // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
                    },
                    class: "", // optional class names space delimited list for title item ex: "text-center"
                });
            }

            if (action.allowedApps.includes("ADYEN")) {
                items.push({
                    name: Integration.ADYEN.name,
                    url: "/integrations" + Integration.ADYEN.integrationPath,
                    icon: Integration.ADYEN.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.ADYEN.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("AMAZON_PAY")) {
                items.push({
                    name: "Amazon Pay (alt)",
                    url: "/integrations" + Integration.AMAZON_PAY.integrationPath + "/v1",
                    icon: Integration.AMAZON_PAY.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.AMAZON_PAY.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("AMAZON_PAY_V2")) {
                items.push({
                    name: Integration.AMAZON_PAY_V2.name,
                    url: "/integrations" + Integration.AMAZON_PAY_V2.integrationPath,
                    icon: Integration.AMAZON_PAY_V2.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.AMAZON_PAY_V2.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("AMAZON_PAYOUT")) {
                items.push({
                    name: Integration.AMAZON_PAYOUT.name,
                    url: "/integrations" + Integration.AMAZON_PAYOUT.integrationPath,
                    icon: "fab fa-amazon",
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.AMAZON_PAYOUT.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("BRAINTREE")) {
                items.push({
                    name: Integration.BRAINTREE.name,
                    url: "/integrations" + Integration.BRAINTREE.integrationPath,
                    icon: Integration.BRAINTREE.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.BRAINTREE.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("GOCARDLESS")) {
                items.push({
                    name: Integration.GOCARDLESS.name,
                    url: "/integrations" + Integration.GOCARDLESS.integrationPath,
                    icon: Integration.GOCARDLESS.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.GOCARDLESS.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("KLARNA")) {
                items.push({
                    name: Integration.KLARNA.name,
                    url: "/integrations" + Integration.KLARNA.integrationPath,
                    icon: Integration.KLARNA.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.KLARNA.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("MOLLIE")) {
                items.push({
                    name: Integration.MOLLIE.name,
                    url: "/integrations" + Integration.MOLLIE.integrationPath,
                    icon: Integration.MOLLIE.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.MOLLIE.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("PAYPAL")) {
                items.push({
                    name: Integration.PAYPAL.name,
                    url: "/integrations" + Integration.PAYPAL.integrationPath,
                    icon: Integration.PAYPAL.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.PAYPAL.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("SHOPIFY_PAYMENTS")) {
                items.push({
                    name: "Shopify Payments",
                    url: "/integrations" + Integration.SHOPIFY_PAYMENTS.integrationPath,
                    icon: Integration.SHOPIFY_PAYMENTS.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.SHOPIFY_PAYMENTS.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("SHOPIFY_POS")) {
                items.push({
                    name: "Shopify POS (Bar)",
                    url: "/integrations" + Integration.SHOPIFY_POS.integrationPath,
                    icon: Integration.SHOPIFY_POS.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.SHOPIFY_POS.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("STRIPE_PAYMENTS")) {
                items.push({
                    name: "Stripe Payments",
                    url: "/integrations" + Integration.STRIPE_PAYMENTS.integrationPath,
                    icon: Integration.STRIPE_PAYMENTS.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.STRIPE_PAYMENTS.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("TIKTOK_PAYMENTS")) {
                items.push({
                    name: Integration.TIKTOK_PAYMENTS.name,
                    url: "/integrations" + Integration.TIKTOK_PAYMENTS.integrationPath,
                    icon: Integration.TIKTOK_PAYMENTS.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.TIKTOK_PAYMENTS.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("ABOUT_YOU_PAYMENTS")) {
                items.push({
                    name: Integration.ABOUT_YOU_PAYMENTS.name,
                    url: "/integrations" + Integration.ABOUT_YOU_PAYMENTS.integrationPath,
                    icon: Integration.ABOUT_YOU_PAYMENTS.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.ABOUT_YOU_PAYMENTS.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("EBAY_PAYMENTS")) {
                items.push({
                    name: Integration.EBAY_PAYMENTS.name,
                    url: "/integrations" + Integration.EBAY_PAYMENTS.integrationPath,
                    icon: Integration.EBAY_PAYMENTS.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.EBAY_PAYMENTS.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("KAUFLAND_PAYMENTS")) {
                items.push({
                    name: Integration.KAUFLAND_PAYMENTS.name,
                    url: "/integrations" + Integration.KAUFLAND_PAYMENTS.integrationPath,
                    icon: Integration.KAUFLAND_PAYMENTS.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.KAUFLAND_PAYMENTS.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("OTTO_PAYMENTS")) {
                items.push({
                    name: Integration.OTTO_PAYMENTS.name,
                    url: "/integrations" + Integration.OTTO_PAYMENTS.integrationPath,
                    icon: Integration.OTTO_PAYMENTS.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.OTTO_PAYMENTS.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("ZALANDO_PAYMENTS") && isZalandoVisible) {
                items.push({
                    name: Integration.ZALANDO_PAYMENTS.name,
                    url: "/integrations" + Integration.ZALANDO_PAYMENTS.integrationPath,
                    icon: Integration.ZALANDO_PAYMENTS.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.ZALANDO_PAYMENTS.identifier) +
                            "-nav-button",
                    },
                });
            }

            if (action.allowedApps.includes("UNZER")) {
                items.push({
                    name: "Unzer",
                    url: "/integrations" + Integration.UNZER.integrationPath,
                    icon: Integration.UNZER.icon,
                    attributes: {
                        dataCy:
                            stringUtils.formatUppercaseIdentifierToLowercase(Integration.UNZER.identifier) +
                            "-nav-button",
                    },
                });
            }

            // BILLING MANAGEMENT
            if (action.allowedModules.includes("BILLING") || action.allowedApps.includes("SHOPIFY")) {
                items.push({
                    title: true,
                    name: "Billing / PDF",
                    wrapper: {
                        // optional wrapper object
                        element: "", // required valid HTML5 element tag
                        attributes: {}, // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
                    },
                    class: "", // optional class names space delimited list for title item ex: "text-center"
                });
            }
            if (action.allowedApps.includes("PATHWAY_BILLING") || action.allowedApps.includes("SHOPIFY")) {
                items.push({
                    name: "Rechnungsprinter",
                    url: "/billing/pathway",
                    icon: "fas fa-file-invoice-dollar",
                    attributes: {
                        dataCy: "billing-nav-button",
                    },
                });
            }

            // EXPENSE MANAGEMENT
            if (action.allowedModules.includes("TRAVEL_EXPENSE")) {
                items.push({
                    title: true,
                    name: "Reisekosten-Tools",
                    wrapper: {
                        // optional wrapper object
                        element: "", // required valid HTML5 element tag
                        attributes: {}, // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
                    },
                    class: "", // optional class names space delimited list for title item ex: "text-center"
                });
            }

            // HR
            if (action.allowedModules.includes("HR")) {
                items.push({
                    title: true,
                    name: "HR-Systeme",
                    wrapper: {
                        // optional wrapper object
                        element: "", // required valid HTML5 element tag
                        attributes: {}, // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
                    },
                    class: "", // optional class names space delimited list for title item ex: "text-center"
                });
            }
            if (action.allowedApps.includes("HRCHANGEREPORT")) {
                items.push({
                    name: "Lohn & Gehalt",
                    url: "/integrations/hrchanges",
                    icon: "fas fa-money-check-alt",
                    attributes: {
                        dataCy: "hrchanges-nav-button",
                    },
                });
            }
            if (action.allowedApps.includes("BAMBOO")) {
                items.push({
                    name: "Bamboo",
                    url: "/integrations/bamboo",
                    icon: "",
                    attributes: {
                        dataCy: "bamboo-nav-button",
                    },
                });
            }

            // CONVERTER
            if (action.allowedModules.includes("CONVERTER")) {
                items.push({
                    title: true,
                    name: "Converter",
                    wrapper: {
                        // optional wrapper object
                        element: "", // required valid HTML5 element tag
                        attributes: {}, // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
                    },
                    class: "", // optional class names space delimited list for title item ex: "text-center"
                });
            }
            if (action.allowedApps.includes("PAYROLL_CONVERTER") || action.allowedApps.includes("QR_CODE_MONKEY")) {
                items.push({
                    name: "Converter",
                    url: "/converter/overview",
                    icon: "fas fa-cogs",
                    attributes: {
                        dataCy: "converter-nav-button",
                    },
                });
            }

            // PLATFORM
            if (action.allowedModules.includes("PLATFORM_INFORMATION")) {
                items.push({
                    title: true,
                    name: "Platform",
                    wrapper: {
                        // optional wrapper object
                        element: "", // required valid HTML5 element tag
                        attributes: {
                            dataCy: "platform-information-nav-button",
                        }, // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
                    },
                    class: "", // optional class names space delimited list for title item ex: "text-center"
                });
            }
            if (action.allowedApps.includes("PLATFORM_STATUS")) {
                items.push({
                    name: "Status",
                    url: "/system/status",
                    icon: "icon-layers",
                    attributes: {
                        dataCy: "platform-status-nav-button",
                    },
                });
            }
            if (
                action.allowedApps.includes("CHARGEBEE") ||
                action.allowedApps.includes("PATHWAY_BILLING") ||
                action.allowedApps.includes("STRIPE_BILLING") ||
                action.allowedApps.includes("STRIPE_PAYMENTS") ||
                action.allowedApps.includes("SHOPIFY")
            ) {
                items.push({
                    name: "Dateien",
                    icon: "fas fa-file",
                    url: "/system/files",
                    attributes: {
                        dataCy: "files-nav-button",
                    },
                });
            }
            if (action.allowedApps.includes("ACCOUNTING_RECORDS")) {
                items.push({
                    name: "Buchungsstapel",
                    url: "/system/buchungsstapel",
                    icon: "icon-cloud-download",
                    attributes: {
                        dataCy: "accounting-records",
                    },
                });
            }
            // NEW In Pathway wrapper - temporarily disabled
            // if (
            //     (action.allowedApps.includes("SHOPIFY") || action.allowedApps.includes("WOO_COMMERCE")) &&
            //     !(
            //         action.allowedApps.includes("AMAZON_PAYOUT") &&
            //         action.allowedApps.includes("AMAZON_PAY") &&
            //         action.allowedApps.includes("AMAZON_ORDER")
            //     )
            // ) {
            // items.push({
            //     title: true,
            //     name: "Neu bei Pathway",
            //     wrapper: {
            //         // optional wrapper object
            //         element: "", // required valid HTML5 element tag
            //         attributes: {}, // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
            //     },
            //     class: "", // optional class names space delimited list for title item ex: "text-center"
            // });
            // }

            if (action.organizationType !== OrganizationType.TAX_AGENCY) {
                items.push({
                    name: "Weitere Integrationen",
                    url: "/addintegrations",
                    icon: "fas fa-folder-plus",
                    attributes: {
                        dataCy: "add-new-integrations-nav-button",
                    },
                });
            }

            /* Temporarily disabled
                          items.push( {
                          name: 'Hilfe Center',
                          url: '/help',
                          icon: 'fa fa-question-circle',
                          attributes: {
                            dataCy: "help-nav-button"
                          }
                        });*/
            return { items: items };
        }

        default:
            return state;
    }
}
